import { render, staticRenderFns } from "./IdleScreen.vue?vue&type=template&id=b4adb352&scoped=true&"
import script from "./IdleScreen.vue?vue&type=script&lang=js&"
export * from "./IdleScreen.vue?vue&type=script&lang=js&"
import style0 from "./IdleScreen.vue?vue&type=style&index=0&id=b4adb352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4adb352",
  null
  
)

export default component.exports